export default function RecoveryScreen({ onRetry }) {
  return (
    <div style={{
      width: '100%',
      minHeight: '100svh',
      background: 'var(--bg)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      animation: 'fadeIn 0.4s ease',
    }}>
      <div style={{
        fontSize: '1.25rem',
        color: 'var(--gold)',
        marginBottom: '1.5rem',
        animation: 'arabicPulse 2s ease-in-out infinite',
        lineHeight: 1,
      }}>
        ✦
      </div>
      <div style={{
        fontFamily: "'Noto Naskh Arabic', serif",
        fontSize: '1.1rem',
        color: 'var(--text2)',
        direction: 'rtl',
        textAlign: 'center',
        marginBottom: '0.5rem',
        lineHeight: 1.8,
        opacity: 0.8,
      }}>
        الديوان يتجدّد
      </div>
      <div style={{
        fontFamily: "'Josefin Sans', sans-serif",
        fontSize: '0.58rem',
        letterSpacing: '0.18em',
        textTransform: 'uppercase',
        color: 'var(--text3)',
        marginBottom: '3rem',
      }}>
        The Dīwān is refreshing
      </div>
      <button
        onClick={onRetry}
        style={{
          background: 'transparent',
          border: '1px solid var(--border)',
          borderRadius: 4,
          padding: '0.75rem 2rem',
          fontFamily: "'Josefin Sans', sans-serif",
          fontSize: '0.62rem',
          letterSpacing: '0.15em',
          textTransform: 'uppercase',
          color: 'var(--em)',
          cursor: 'pointer',
        }}
      >
        Continue →
      </button>
    </div>
  );
}
